/**
 * Redux reducer for settings state, managing user profile data and preferences.
 *
 * @module redux/settings/reducer
 * @author Snowfly
 * @version 1.0.0
 */
import {
    FETCH_REQUEST,
    FETCH_FAILURE,
    FETCH_STATUS,
    FETCH_SUB_STATUS,
    FETCH_ROLES,
    FETCH_GROUPS,
    SAVE_SETTINGS,
    UPDATE_PASSWORD,
} from './settingsType';

/**
 * Initial state for the settings reducer.
 *
 * @type {Object}
 * @property {boolean} isLoading - Whether an async operation is in progress.
 * @property {Array} data - Generic data payload from the last fetch.
 * @property {string|null} status - Last HTTP status or error message.
 * @property {Object} userData - Current user's profile form data.
 * @property {Object} selectStatus - Available status options for select inputs.
 * @property {Object} selectSubStatus - Available sub-status options for select inputs.
 * @property {Object} selectRoles - Available roles for select inputs.
 * @property {Array} selectGroups - Available groups for select inputs.
 */
const initialState = {
    isLoading: false,
    data: [],
    status: null,
    userData: {
        _id: '',
        first_name: '',
        last_name: '',
        title: '',
        email_id: '',
        phone_number: '',
        profile_pic_url: '',
        status: '',
        sub_status: '',
        role: '',
        schedule: '',
        duration: '',
        employment: '',
        workplace: '',
        joined_company: '',
        probation: '',
        promoted: '',
        groups: [],
        outsourcer: '',
    },
    selectStatus: {},
    selectSubStatus: {},
    selectRoles: {},
    selectGroups: [],
};

/**
 * Settings reducer function.
 *
 * @param {Object} state - Current settings state.
 * @param {Object} action - Dispatched Redux action.
 * @returns {Object} The next settings state.
 */
const reducer = (state = initialState, action) => {
    const {payload} = action;
    switch (action.type) {
        case FETCH_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case FETCH_FAILURE:
            return (() => {
                const status = payload.message ? payload.message.split(' ') : [];
                if (status[status.length - 1] === '403') {
                    localStorage.setItem('redirectUrl', '/permissiondenied');
                    window.location.href = '/permissiondenied';
                    return {
                        ...state,
                        isLoading: false,
                        permissionDenied: true,
                    };
                }
                if (status[status.length - 1] === '401') {
                    window.location.href = '/login';
                    localStorage.clear('token');
                    localStorage.clear('user');
                    return {
                        ...state,
                        isLoading: false,
                        isAuth: false,
                        status: action.payload,
                    };
                }
                return {
                    ...state,
                    isLoading: false,
                    status: action.payload,
                };
            })();

        case FETCH_STATUS:
            return {
                ...state,
                isLoading: true,
                selectStatus: action.payload.data,
                status: action.payload.status,
            };
        case FETCH_SUB_STATUS:
            return {
                ...state,
                isLoading: true,
                selectSubStatus: action.payload.data,
                status: action.payload.status,
            };
        case FETCH_ROLES:
            return {
                ...state,
                isLoading: true,
                selectRoles: action.payload.data,
                status: action.payload.status,
            };
        case FETCH_GROUPS:
            return {
                ...state,
                isLoading: true,
                selectGroups: action.payload.data,
                status: action.payload.status,
            };
        case SAVE_SETTINGS:
            return {
                ...state,
                userData: {
                    ...state.userData,
                    ...action.payload,
                },
            };
        case UPDATE_PASSWORD:
            return {
                ...state,
                result: action.payload.data,
            };
        default:
            return state;
    }
};
export default reducer;
